var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconEditorBold = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.06689 3.75004C4.06689 2.83337 4.81689 2.08337 5.73356 2.08337H10.0002C12.1836 2.08337 13.9586 3.85837 13.9586 6.04171C13.9586 8.22504 12.1836 10 10.0002 10H4.06689V3.75004Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06689 10H11.9836C14.1669 10 15.9419 11.775 15.9419 13.9583C15.9419 16.1417 14.1669 17.9167 11.9836 17.9167H5.73356C4.81689 17.9167 4.06689 17.1667 4.06689 16.25V10V10Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconEditorBold);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-editor-bold.ea2c761cec36c453acf3850d22efaa7a.svg";